module.exports = "/images/icon-processing.png?5990a7a72a739646ebe3da92745a895d";